import * as _ from "lodash";

import { ChartDataPointXAxisType, ISODuration, DataDictionary } from "@ctra/api";
import { Epoch, TS } from "@ctra/utils";

/**
 * Format the x-axis label
 * @param {number} value
 * @param {{type: ChartDataPointXAxisType, bucketSize: ISODuration}} formatOptions
 * @param {{mayLocalise?: boolean, mayConvertToUTC?: boolean}} flags
 * @returns {string}
 */
export const formatXLabel = (
  value: string | number,
  formatOptions: {
    type?: ChartDataPointXAxisType;
    bucketSize?: ISODuration;
  } = {
    type: ChartDataPointXAxisType.date,
    bucketSize: DataDictionary.DefaultDataInterval
  },
  flags: { mayLocalise?: boolean; mayConvertToUTC?: boolean } = {}
): string => {
  const { type, bucketSize } = formatOptions;
  const { mayLocalise, mayConvertToUTC } = flags;

  /**
   * Make an epoch from the value
   * @type {moment.Moment}
   */
  let moment: moment.Moment = _.isNumber(value) ? Epoch.asMoment(value) : TS.asMoment(value);

  let format = "L";

  if (type) {
    switch (type) {
      case ChartDataPointXAxisType.weekDay:
        format = "DD MMM";
        break;
      case ChartDataPointXAxisType.month:
        format = "MMM YYYY";
        break;
    }
  } else if (bucketSize) {
    switch (bucketSize) {
      case "P1D":
        format = "L";
        break;
      case "P1W":
        format = "DD MMM";
        break;
      case "P1M":
        format = "MMM YYYY";
        break;
      case "P1Y":
        format = "YYYY";
        break;
    }
  }

  if (mayConvertToUTC) {
    moment = moment.utc();
  }

  if (mayLocalise) {
    moment = moment.local();
  }

  return moment.format(format);
};
